import { createStyles, makeStyles } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'relative',
      top: '0px',
      width: '320px',
      marginTop: '0px',
      marginBottom: '26px',
      padding: '0px',
    },
    normalPaper: {
      backgroundColor: '#ff0000',
    },
    picker: {
      '& .MuiPickersBasePicker-pickerView': {
        minHeight: '505px',
      },
      position: 'relative',
      marginBottom: '500px',
    },
    monthField: {
      position: 'absolute',
      marginTop: '15px',
      marginLeft: '15px',
      width: '130px',
      height: '30px',
      fontSize: '16px',
      display: 'inline',
      zIndex: 0,
    },
    monthLabel: {
      fontSize: '12px',
    },
    yearField: {
      position: 'absolute',
      marginTop: '15px',
      marginBottom: '10px',
      marginLeft: '162px',
      width: '130px',
      height: '30px',
      fontSize: '16px',
      display: 'inline',
      zIndex: 0,
    },
    plaster: {
      backgroundColor: '#FFFFFF',
      position: 'absolute',
      width: '100%',
      height: '30px',
      top: '5px',
      zIndex: 0,
    },
  }),
);

export const materialTheme = createTheme({
  palette: {
    primary: {
      main: '#3C419A',
    },
  },
});
